"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDemoMode = exports.getPageSelected = exports.getCurrentPageUxAnswered = exports.getQueryParamsFinish = exports.getQueryParamsAnswers = exports.getFirstQuestionError = exports.getQuestionErrors = exports.getShortTextQuestionWithLabel = exports.getNextPageIndex = exports.getQuestionInPage = exports.getSurveyConditions = exports.getConfig = exports.getIsHaveUxQuestions = exports.getSurveyPreset = exports.getSurveyConfig = exports.getInterviewId = exports.getLocation = exports.getDisplayHiddenQuestions = exports.getLang = exports.getState = exports.getScreenoutState = exports.getFinishState = exports.getMetrikaCountersData = exports.getMetrikaTitle = exports.getMetrika = exports.getScreenout = exports.getPageId = exports.getIsPollStarted = exports.getNextButtonEnabled = exports.getCurrentPageSelectedOptions = exports.getInvalidWidgetsOnCurrentPage = exports.getInvalidQuestionsOnCurrentPage = exports.isAllRequiredQuestionsOnPageAnswered = exports.getNextBtnBehaviour = exports.isNodeValid = exports.getLogicProcessing = exports.getCurrentPageNodes = exports.getCharLimits = exports.getPages = exports.getCurrentPage = exports.getRetpath = exports.getSlug = exports.getQuestion = exports.getWidgets = exports.getQuestions = void 0;
const effects_1 = require("redux-saga/effects");
const lang_detect_1 = require("src/utils/lang-detect");
const client_config_1 = __importDefault(require("src/utils/client-config"));
const questions_1 = require("src/types/questions");
function getQuestions(state) {
    return state.questions;
}
exports.getQuestions = getQuestions;
function getWidgets(state) {
    return state.widgets;
}
exports.getWidgets = getWidgets;
function getQuestion(state, questionIndex) {
    return state.questions[questionIndex];
}
exports.getQuestion = getQuestion;
function getSlug(state) {
    return state.survey.slug;
}
exports.getSlug = getSlug;
function getRetpath(state) {
    return state.survey.retpath;
}
exports.getRetpath = getRetpath;
function getCurrentPage(state) {
    return state.pages.currentPage;
}
exports.getCurrentPage = getCurrentPage;
function getPages(state) {
    return state.pages.list;
}
exports.getPages = getPages;
function getCharLimits(state) {
    return state.survey.charLimits || {};
}
exports.getCharLimits = getCharLimits;
function getCurrentPageNodes(state, nodeType = 'question') {
    const currentPageIndex = getCurrentPage(state);
    const pages = getPages(state);
    const currentPage = pages[currentPageIndex];
    return (currentPage ? currentPage.children : [])
        .filter(({ type }) => type === nodeType)
        .map(({ id }) => id);
}
exports.getCurrentPageNodes = getCurrentPageNodes;
function getLogicProcessing(state) {
    return state.survey.isLogicProcessing;
}
exports.getLogicProcessing = getLogicProcessing;
function isNodeValid(node) {
    if (!node.visible) {
        return true;
    }
    return node.isValid;
}
exports.isNodeValid = isNodeValid;
function getNextBtnBehaviour(state) {
    return state.survey.nextBtnBehaviour;
}
exports.getNextBtnBehaviour = getNextBtnBehaviour;
function isAllRequiredQuestionsOnPageAnswered(state) {
    const questions = getQuestions(state);
    const currentPageQuestions = getCurrentPageNodes(state);
    return currentPageQuestions.every(id => !questions[id].required || isNodeValid(questions[id]));
}
exports.isAllRequiredQuestionsOnPageAnswered = isAllRequiredQuestionsOnPageAnswered;
function getInvalidQuestionsOnCurrentPage(state) {
    const questions = getQuestions(state);
    const currentPageQuestions = getCurrentPageNodes(state);
    return currentPageQuestions.filter(id => !isNodeValid(questions[id]));
}
exports.getInvalidQuestionsOnCurrentPage = getInvalidQuestionsOnCurrentPage;
function getInvalidWidgetsOnCurrentPage(state) {
    const widgets = getWidgets(state);
    const currentPageWidgets = getCurrentPageNodes(state, 'widget');
    return currentPageWidgets.filter(id => !isNodeValid(widgets[id]));
}
exports.getInvalidWidgetsOnCurrentPage = getInvalidWidgetsOnCurrentPage;
function getCurrentPageSelectedOptions(state) {
    const questions = getQuestions(state);
    const currentPageQuestions = getCurrentPageNodes(state);
    return currentPageQuestions.reduce((acc, qid) => {
        const question = questions[qid];
        if ((0, questions_1.isQuestionWithOptions)(question)) {
            const options = question.options || [];
            acc.push(...options.filter(({ checked }) => checked).map(({ id }) => Number(id)));
        }
        return acc;
    }, []);
}
exports.getCurrentPageSelectedOptions = getCurrentPageSelectedOptions;
// eslint-disable-next-line max-statements, complexity
function getNextButtonEnabled(state) {
    const cfg = getConfig(state);
    const nextBtnBehaviour = getNextBtnBehaviour(state);
    const allRequiredAnswered = isAllRequiredQuestionsOnPageAnswered(state);
    const invalidQuestions = getInvalidQuestionsOnCurrentPage(state);
    const invalidWidgets = getInvalidWidgetsOnCurrentPage(state);
    const disabled = (cfg.theme === 'ugc-cab' && invalidQuestions.length > 0) ||
        invalidWidgets.length > 0;
    if (nextBtnBehaviour === 'disabledUntilValid') {
        return !disabled && allRequiredAnswered;
    }
    return !disabled;
}
exports.getNextButtonEnabled = getNextButtonEnabled;
// в опросе что-то отвечали/кликали, было действие от пользователя
function getIsPollStarted(state) {
    return state.survey.isPollStarted;
}
exports.getIsPollStarted = getIsPollStarted;
function getPageId(state, pageIndex) {
    return state.pages.list[pageIndex].id;
}
exports.getPageId = getPageId;
function getScreenout(state, pageId) {
    return state.screenouts[pageId];
}
exports.getScreenout = getScreenout;
function getMetrika(state) {
    return state.survey.metrika;
}
exports.getMetrika = getMetrika;
function getMetrikaTitle(state) {
    return state.survey.metrikaTitle;
}
exports.getMetrikaTitle = getMetrikaTitle;
function getMetrikaCountersData(state) {
    return state.survey.metrikaCounters;
}
exports.getMetrikaCountersData = getMetrikaCountersData;
function getFinishState(state) {
    return state.survey.finish;
}
exports.getFinishState = getFinishState;
function getScreenoutState(state) {
    return state.survey.screenout;
}
exports.getScreenoutState = getScreenoutState;
function getState(state) {
    return state;
}
exports.getState = getState;
function getLang(state) {
    return state.lang || (0, lang_detect_1.langDetect)();
}
exports.getLang = getLang;
function getDisplayHiddenQuestions(state) {
    var _a;
    return (_a = state.survey.displayHiddenQuestions) !== null && _a !== void 0 ? _a : false;
}
exports.getDisplayHiddenQuestions = getDisplayHiddenQuestions;
function getLocation(state) {
    return state.location;
}
exports.getLocation = getLocation;
function getInterviewId(state) {
    return state.survey._ivid;
}
exports.getInterviewId = getInterviewId;
function getSurveyConfig(state) {
    return state.config;
}
exports.getSurveyConfig = getSurveyConfig;
function getSurveyPreset(state) {
    return state.survey.surveyPreset;
}
exports.getSurveyPreset = getSurveyPreset;
function getIsHaveUxQuestions(state) {
    const questions = getQuestions(state);
    const isHaveUxQuestions = Object.keys(questions)
        .map(qId => questions[qId])
        .some(q => ['ux'].includes(q.type));
    return isHaveUxQuestions;
}
exports.getIsHaveUxQuestions = getIsHaveUxQuestions;
function getConfig(state) {
    const { host, pathname, search } = getLocation(state);
    const isHaveUxQuestions = getIsHaveUxQuestions(state);
    return (0, client_config_1.default)({ host, pathname, search, isHaveUxQuestions });
}
exports.getConfig = getConfig;
function getSurveyConditions(state) {
    return state.survey.conditions || {}; // {} в случае загрузки опроса без ветки conditions из LS
}
exports.getSurveyConditions = getSurveyConditions;
function* getQuestionInPage(pageIndex) {
    const pages = yield (0, effects_1.select)(getPages);
    const questions = yield (0, effects_1.select)(getQuestions);
    const indexlist = pages[pageIndex].questionIds;
    return indexlist.map(index => {
        return questions[index];
    });
}
exports.getQuestionInPage = getQuestionInPage;
function getNextPageIndex({ pagesList, currPageIndex, conditions = {} }) {
    const countPages = pagesList.length;
    let nextPageIndex = currPageIndex;
    let page;
    // завершаем опрос если сработало условие
    if (conditions.finish) {
        return -1;
    }
    do {
        page = pagesList[++nextPageIndex];
    } while (nextPageIndex < countPages && !page.visible);
    if (nextPageIndex === countPages) {
        nextPageIndex = -1;
    }
    return nextPageIndex;
}
exports.getNextPageIndex = getNextPageIndex;
function* getShortTextQuestionWithLabel(questionLabel) {
    const questions = yield (0, effects_1.select)(getQuestions);
    const questionsList = Object.keys(questions).map(key => questions[key]);
    const [questionShortText] = questionsList.filter(({ type, label }) => type === 'shortText' && label === questionLabel);
    return questionShortText;
}
exports.getShortTextQuestionWithLabel = getShortTextQuestionWithLabel;
function getQuestionErrors(question) {
    return (question.errorVisible && question.errors) || [];
}
exports.getQuestionErrors = getQuestionErrors;
function getFirstQuestionError(state) {
    const questions = getQuestions(state);
    const firstQuestionIdWithErrors = Object.keys(questions).find(qId => getQuestionErrors(questions[qId]).length > 0);
    const isHaveErrors = firstQuestionIdWithErrors !== undefined;
    return isHaveErrors ? questions[firstQuestionIdWithErrors].errors[0] : null;
}
exports.getFirstQuestionError = getFirstQuestionError;
function getQueryParamsAnswers(state) {
    const { search } = getLocation(state);
    const searchParams = new URLSearchParams(search);
    const queryParamsAnswers = searchParams.get('answers');
    if (!queryParamsAnswers) {
        return;
    }
    const answers = JSON.parse(queryParamsAnswers);
    if (Array.isArray(answers) && answers.length > 0) {
        return answers;
    }
}
exports.getQueryParamsAnswers = getQueryParamsAnswers;
function getQueryParamsFinish(state) {
    const { search } = getLocation(state);
    const searchParams = new URLSearchParams(search);
    const finish = searchParams.get('finish');
    if (finish === undefined || finish === null) {
        return true;
    }
    switch (finish) {
        case '0':
        case 'false':
            return false;
        default:
            return true;
    }
}
exports.getQueryParamsFinish = getQueryParamsFinish;
function getCurrentPageUxAnswered(state) {
    var _a, _b;
    const currentPageQuestions = getCurrentPageNodes(state);
    const firstQuestion = getQuestion(state, currentPageQuestions[0]);
    if ((firstQuestion === null || firstQuestion === void 0 ? void 0 : firstQuestion.type) === 'ux' && currentPageQuestions.length > 1) {
        return (_b = (_a = firstQuestion.value) === null || _a === void 0 ? void 0 : _a.some(data => data.event === 'click_target')) !== null && _b !== void 0 ? _b : false;
    }
    if ((firstQuestion === null || firstQuestion === void 0 ? void 0 : firstQuestion.type) !== 'ux') {
        return true;
    }
    return false;
}
exports.getCurrentPageUxAnswered = getCurrentPageUxAnswered;
// eslint-disable-next-line max-statements
function getPageSelected(state) {
    var _a;
    const cfg = getConfig(state);
    const pages = getPages(state);
    let targetPageIndex = null;
    let pageIsVisible = true;
    if (((_a = cfg === null || cfg === void 0 ? void 0 : cfg.header) === null || _a === void 0 ? void 0 : _a.enable) && (cfg === null || cfg === void 0 ? void 0 : cfg.pageId) && pages.length) {
        const targetPageId = parseInt(cfg === null || cfg === void 0 ? void 0 : cfg.pageId, 10);
        targetPageIndex = pages.findIndex(page => page.id === targetPageId);
        const pagesInvisible = new Set(pages.reduce((acc, page) => {
            if (!page.visible) {
                acc.push(page.id);
            }
            return acc;
        }, []));
        if (pagesInvisible.has(targetPageId)) {
            pageIsVisible = false;
        }
    }
    return {
        targetPageIndex,
        pageIsVisible
    };
}
exports.getPageSelected = getPageSelected;
function getDemoMode(state) {
    return state.survey.demoMode;
}
exports.getDemoMode = getDemoMode;
